const initState =
{
  loading   : true,
  timer     : false,
}

const appReducer = (state = initState, action) =>
{
  switch (action.type)
  {    
    case 'LOADING':
      return {
        ...state,
        loading: action.loading
      };

    case 'SET_TIMER':
      return {
        ...state,
        timer: action.timer
      };

    default:
      return state; 
  }
}

export default appReducer;